import { useState, useCallback } from "react";
import Highcharts from "../config/highcharts-config";

interface UseDonutChartLegendReturn {
  visiblePoints: Record<number, boolean>;
  chartInstance: Highcharts.Chart | null;
  handleLegendClick: (pointIndex: number) => void;
  chartCallback: (chart: Highcharts.Chart) => void;
}

export const useDonutChartLegend = (): UseDonutChartLegendReturn => {
  const [chartInstance, setChartInstance] = useState<Highcharts.Chart | null>(
    null,
  );
  const [visiblePoints, setVisiblePoints] = useState<Record<number, boolean>>(
    {},
  );

  // Toggle sidebar open/close

  // Handle legend item click - mimics Highcharts native legend behavior
  const handleLegendClick = useCallback(
    (pointIndex: number) => {
      if (chartInstance && chartInstance.series[0]) {
        const point = chartInstance.series[0].data[pointIndex];
        if (point) {
          // Get current visibility BEFORE toggling
          const currentlyVisible = point.visible;

          // Toggle visibility using Highcharts method
          point.setVisible(!currentlyVisible, true);

          // Update state with NEW visibility (opposite of current)
          setVisiblePoints((prev) => ({
            ...prev,
            [pointIndex]: !currentlyVisible,
          }));
        }
      }
    },
    [chartInstance],
  );

  // Callback to capture chart instance and initialize visible points
  const chartCallback = useCallback((chart: Highcharts.Chart) => {
    setChartInstance(chart);
    // Initialize all points as visible
    const initialVisible: Record<number, boolean> = {};
    chart.series[0]?.data.forEach((point, index) => {
      initialVisible[index] = point.visible !== false;
    });
    setVisiblePoints(initialVisible);
  }, []);

  return {
    visiblePoints,
    chartInstance,
    handleLegendClick,
    chartCallback,
  };
};
